import axios from "axios";

export const createOrUpdateUser = async (authtoken) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL || 'https://printspaceai.com/api'}/create-or-update-user`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );
};

export const currentUser = async (authtoken) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL || 'https://printspaceai.com/api'}/current-user`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );
};

export const currentAdmin = async (authtoken) => {
  return await axios.post(
    `${process.env.REACT_APP_API_URL || 'https://printspaceai.com/api'}/current-admin`,
    {},
    {
      headers: {
        authtoken,
      },
    }
  );
};

export const loginWithEmail = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    
    const res = await axios.post(
      `${apiUrl}/v1/login`,
      payload
    );
    
    if (res?.status === 200) {
      return res; // Success response
    } else {
      throw new Error("Login failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    console.error("Login error");
    throw e;
  }
};

export const registerUser = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    console.log("Register API URL:", `${apiUrl}/v1/register`);
    
    const res = await axios.post(
      `${apiUrl}/v1/register`,
      payload
    );
    if (res?.status >= 200 && res?.status < 300) {
      return res;
    }
    const err = new Error(`Registration failed (HTTP ${res?.status})`);
    err.response = { data: { detail: `Unexpected response status ${res?.status}` } };
    throw err;
  } catch (e) {
    console.error("Register error:", e);
    throw e; // Rethrow the error for proper handling
  }
};

export const requestForgotPass = async (email) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/request-reset-password?email=${email}`
    );
    if (res?.status === 201 || res?.status === 200) {
      return res; // Success response
    } else {
      throw res // Throw an actual error for non-200 status
    }
  } catch (e) {
    throw e; // Rethrow the error for proper handling
  }
};

export const verifyOTPApi = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/verify-otp`,
      payload
    );
    if (res?.status === 200) {
      return res; // Success response
    } else {
      throw new Error("Register failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    throw e; // Rethrow the error for proper handling
  }
};

export const resendOTPApi = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/resend-otp`,
      payload
    );
    if (res?.status === 200) {
      return res; // Success response
    } else {
      throw new Error("Register failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    throw e; // Rethrow the error for proper handling
  }
};



export const verifyOTPForgotPass = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/reset-password`,
      payload
    );
    if (res?.status === 200 || res?.status === 201) {
      return res; // Success response
    } else {
      throw new Error("Register failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    throw e; // Rethrow the error for proper handling
  }
};

export const contactUsAPI = async (payload) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/contact_us`,
      payload
    );
    if (res?.status === 200) {
      return res; // Success response
    } else {
      throw new Error("Register failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    throw e; // Rethrow the error for proper handling
  }
};

export const googleLogin = async (idToken) => {
  try {
    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    console.log("Initiating Google authentication");
    // Removed sensitive token logging for security
    
    const res = await axios.post(
      `${apiUrl}/v1/google-login`,
      { id_token: idToken }
    );
    
    console.log("Google Login response:", res);
    
    if (res?.status === 200) {
      return res; // Success response
    } else {
      throw new Error("Google login failed"); // Throw an actual error for non-200 status
    }
  } catch (e) {
    console.error("Google Login error:", e);
    console.error("Google Login error response:", e.response?.data);
    throw e; // Rethrow the error for proper handling
  }
};

/**
 * Refresh the access token using the refresh token
 */
export const refreshAccessToken = async () => {
  try {
    const userData = localStorage.getItem("userData");
    if (!userData) {
      throw new Error("No user data found");
    }

    const parsed = JSON.parse(userData);
    const refreshToken = parsed?.refresh_token;

    if (!refreshToken) {
      throw new Error("No refresh token found");
    }

    const apiUrl = process.env.REACT_APP_API_URL || 'https://printspaceai.com/api';
    const res = await axios.post(
      `${apiUrl}/v1/refresh-token`,
      { refresh_token: refreshToken }
    );

    // Backend returns tokens directly in response.data
    // Handle both direct format and wrapped format
    const tokenData = res?.data?.access_token ? res.data : (res?.data?.data || res?.data);
    
    if (tokenData && tokenData.access_token) {
      // Update tokens in localStorage
      const updatedUserData = {
        ...parsed,
        access_token: tokenData.access_token,
        refresh_token: tokenData.refresh_token || refreshToken, // Use new refresh token if provided
        id_token: tokenData.id_token || parsed.id_token, // Use new id_token if provided
      };
      localStorage.setItem("userData", JSON.stringify(updatedUserData));
      console.log("✅ Token refreshed successfully");
      return updatedUserData;
    }

    throw new Error("Token refresh failed - invalid response format");
  } catch (error) {
    console.error("Token refresh error:", error);
    // If refresh fails, clear user data (session expired)
    if (error.response?.status === 401 || error.response?.status === 400) {
      localStorage.removeItem("userData");
      throw new Error("Session expired. Please log in again.");
    }
    throw error;
  }
};
